import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { icURL } from "./DataContextCopy";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContext } from "./LoginContextCopy";

export const SurveysContext = createContext([]);

export const SurveysProvider = ({ children }) => {
  const { isLoginState } = useContext(LoginContext);
  const location = useLocation();
  const navigate = useNavigate();
  const surveySeqno = location.state?.seqno || null;

  // 설문리스트 (메인목록조회)
  const [userSurveyList, setUserSurveyList] = useState([]);

  // 데이터 값 불러오기
  const [svSeqno, setSvSeqno] = useState(surveySeqno || 0);

  // 질문 조회
  const [questList, setQuestList] = useState([]);
  const getQuestSubmit = async (seqno) => {
    try {
      const res = await axios.get(`${icURL}/api/survey/question`, {
        params: {
          sv_seqno: seqno,
        },
      });
      setQuestList(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  // 답변 조회
  const [answerList, setAnswerList] = useState([]);
  const getAnswerListSubmit = async (seqno) => {
    try {
      const res = await axios.get(`${icURL}/api/survey/answer`, {
        params: {
          sv_main_seqno: seqno,
        },
      });
      setAnswerList(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const surveyUserAllList = async () => {
    try {
      const response = await axios.get(`${icURL}/api/survey`, {
        params: {
          currentPage: 1,
          currentElement: 10,
          type: "current",
        },
      });

      const surveyList = response.data.data;

      if (surveyList.length > 0) {
        setUserSurveyList(surveyList);
        const firstSeqno = surveyList[0].seqno;
        setSvSeqno(firstSeqno);
        getQuestSubmit(firstSeqno);
        getAnswerListSubmit(firstSeqno);
      } else {
        navigate("//");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (surveySeqno) {
      getQuestSubmit(surveySeqno);
      getAnswerListSubmit(surveySeqno);
    } else {
      surveyUserAllList();
    }
  }, [surveySeqno, isLoginState]);

  //   투표하기
  const [vote, setVote] = useState([]);
  const voteSubmit = async () => {
    try {
      await axios.post(`${icURL}/api/survey/vote`, vote);
      alert("설문에 참여해 주셔서 감사합니다.");
      navigate("//");
      window.location.reload();
    } catch (err) {
      console.error(err);
      if (err.response) {
        console.log("Response data:", err.response.data);
        console.log("Response status:", err.response.status);
        console.log("Response headers:", err.response.headers);
      }
    }
  };

  return (
    <SurveysContext.Provider
      value={{
        userSurveyList,
        setUserSurveyList,
        surveyUserAllList,

        svSeqno,
        setSvSeqno,
        questList,
        setQuestList,
        getQuestSubmit,
        answerList,
        setAnswerList,
        getAnswerListSubmit,
        vote,
        setVote,
        voteSubmit,
      }}
    >
      {children}
    </SurveysContext.Provider>
  );
};
